import(/* webpackMode: "eager", webpackExports: ["Avatar","AvatarImage","AvatarFallback"] */ "/var/www/moneyoval/moneyoval-frontend/components/ui/avatar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Separator"] */ "/var/www/moneyoval/moneyoval-frontend/components/ui/separator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/var/www/moneyoval/moneyoval-frontend/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/var/www/moneyoval/moneyoval-frontend/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/moneyoval/moneyoval-frontend/views/articles/components/ArticleDate.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/moneyoval/moneyoval-frontend/views/articles/embedded.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/moneyoval/moneyoval-frontend/views/articles/poll.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/moneyoval/moneyoval-frontend/views/articles/related-articles.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TOC"] */ "/var/www/moneyoval/moneyoval-frontend/views/articles/toc.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/moneyoval/moneyoval-frontend/views/bookmark/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/moneyoval/moneyoval-frontend/views/comments/commentSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/moneyoval/moneyoval-frontend/views/detect-user/detectUser.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CollapsibleShare"] */ "/var/www/moneyoval/moneyoval-frontend/views/share/collapableShare.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HorizontalShare"] */ "/var/www/moneyoval/moneyoval-frontend/views/share/horizontalShare.tsx");
